import React from "react";
import {
  SiPhonepe,
  SiGooglepay,
  SiPaytm,
  SiVisa,
  SiMastercard,
} from "react-icons/si";

export const PhonePeLogo = () => (
  <div className="flex h-7 items-center justify-center gap-1.5 rounded-md border border-purple-200 bg-white px-2 py-0.5 shadow-2xs">
    <div className="flex h-5 w-5 items-center justify-center rounded-full bg-[#5f259f] text-white p-0.5">
      <SiPhonepe className="h-3.5 w-3.5" />
    </div>
    <span className="text-xs font-black text-[#5f259f] tracking-tight">
      PhonePe
    </span>
  </div>
);

export const GooglePayLogo = () => (
  <div className="flex h-7 items-center justify-center gap-1.5 rounded-md border border-gray-200 bg-white px-2 py-0.5 shadow-2xs">
    <SiGooglepay className="h-5 w-auto text-gray-800" />
  </div>
);

export const PaytmLogo = () => (
  <div className="flex h-7 items-center justify-center gap-1 rounded-md border border-blue-200 bg-white px-2 py-0.5 shadow-2xs">
    <SiPaytm className="h-5 w-auto text-[#002970]" />
  </div>
);

export const VisaLogo = () => (
  <div className="flex h-7 items-center justify-center rounded-md border border-gray-200 bg-white px-2 py-0.5 shadow-2xs">
    <SiVisa className="h-4 w-auto text-[#1A1F71]" />
  </div>
);

export const MastercardLogo = () => (
  <div className="flex h-7 items-center justify-center rounded-md border border-gray-200 bg-white px-2 py-0.5 shadow-2xs">
    <SiMastercard className="h-4 w-auto text-[#EB001B]" />
  </div>
);

export const RuPayLogo = () => (
  <div className="flex h-7 items-center justify-center gap-1 rounded-md border border-gray-200 bg-white px-2 py-0.5 shadow-2xs">
    <svg className="h-4 w-auto" viewBox="0 0 74 24" fill="none">
      <path d="M5 4l6 8-6 8h5l6-8-6-8H5z" fill="#097938" />
      <path d="M12 4l6 8-6 8h5l6-8-6-8h-5z" fill="#F37021" />
      <text
        x="30"
        y="17"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="900"
        fontSize="14"
        fill="#231F20"
      >
        RuPay
      </text>
    </svg>
  </div>
);

export const CodLogo = () => (
  <div className="flex h-7 items-center justify-center gap-1.5 rounded-md border border-emerald-300 bg-emerald-50 px-2.5 py-0.5 shadow-2xs">
    <svg className="h-4 w-auto" viewBox="0 0 28 24" fill="none">
      <rect x="2" y="4" width="24" height="16" rx="2.5" fill="#046a38" />
      <circle cx="14" cy="12" r="4.5" fill="#ffffff" />
      <text
        x="14"
        y="15.5"
        textAnchor="middle"
        fontFamily="sans-serif"
        fontWeight="bold"
        fontSize="10"
        fill="#046a38"
      >
        ₹
      </text>
    </svg>
    <span className="text-[11px] font-black text-[#046a38] tracking-wider">
      COD
    </span>
  </div>
);
